import BaseService from "../BaseService";
import {
  Case,
  CaseCategories,
  CaseOrderBy,
  CaseStatistics,
  CaseStatus,
} from "../../stores/CaseStore/types";
import { UserRoles } from "../../stores/AuthStore/types";

class CaseService extends BaseService {
  async getCase(id: string): Promise<Case> {
    return this.fetch<Case>(`cases/${id}`).then(
      (result): Case => ({ ...result, id: (result as any)._id })
    );
  }

  async getCases(params?: {
    [key: string]: string | undefined;
  }): Promise<Case[]> {
    return this.fetch<Case[]>("cases", params).then((cases) =>
      cases?.map(
        (caseItem): Case => ({ ...caseItem, id: (caseItem as any)._id })
      )
    );
  }

  getCaseStatistics(): Promise<CaseStatistics> {
    return this.fetch<CaseStatistics>("caseStatistics");
  }

  getCaseCategories(): Promise<CaseCategories> {
    return this.fetch<CaseCategories>("mock/caseCategories.json");
  }

  async searchCases(
    keyword: string,
    orderBy: CaseOrderBy,
    page: number,
    size: number = 10,
    status?: CaseStatus,
    role?: UserRoles
  ): Promise<{ cases: Case[]; count: number }> {
    return this.fetch<{ cases: Case[]; count: any }[]>("searchCases", {
      keyword,
      orderBy,
      page: page.toString(),
      size: size.toString(),
      status,
      role,
    }).then((result) => ({
      ...result[0],
      cases: result[0]?.cases?.map(
        (caseItem): Case => ({ ...caseItem, id: (caseItem as any)._id })
      ),
      count: result[0]?.count[0]?.count || 0,
    }));
  }

  createCase(data: Case): Promise<void> {
    return this.post<void, Case>("cases", data);
  }

  updateCase(data: Case, id: string): Promise<Case> {
    return this.put<Case, Case>(`cases/${id}`, data);
  }

  updateStatus(
    cases: string[],
    status: CaseStatus,
    rejectReason?: string
  ): Promise<void> {
    return this.put("updateCaseStatus", {
      cases,
      status,
      rejectReason,
    });
  }

  deactivateCase(caseId: string): Promise<void> {
    return this.put("deactivateCase", {
      caseId,
    });
  }
}

export default CaseService;
